module.exports = __webpack_public_path__ + "static/media/subOutlook1.68475b79.png";